<template>
  <div class="home">
    <el-row type="flex" justify="center">
      <el-col :md="18" :lg="14">
        <el-carousel :interval="3000" indicator-position="none">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <div class="banner-item">{{ item.text }}</div>
            <!-- <img :src="item.url" alt="" /> -->
            <el-image fit="fill" :src="item.url"></el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <!-- 游戏示例 -->
    <el-row type="flex" justify="center">
      <el-col :md="18" :lg="14">
        <el-row class="mt">
          <el-col>
            <el-divider content-position="center"><h1>旗下游戏</h1></el-divider>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col
            :lg="24"
            :xl="12"
            v-for="item in gameList"
            :key="item.id"
            class="mb"
          >
            <el-card shadow="hover">
              <div class="game">
                <el-image :src="item.url"></el-image>
                <div class="right">
                  <div class="title">{{ item.name }}</div>
                  <div class="desc">{{ item.desc }}</div>
                  <div class="kid">{{ item.kid }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      gameList: [
        {
          id: 0,
          name: "阿瓦隆",
          url: require("@/assets/images/icon/icon1.png"),
          desc:
            "阿瓦隆是一款玩家扮演正邪双方对抗的游戏，玩家需要在游戏中赢藏自己的身份。正义一方需成功完成三个任务并隐藏梅林不被刺客刺杀才能胜利，邪恶一方需让三次任务以失败告终或成功刺杀梅林才能获得胜利。",
          kid: "标签：游戏、桌游、烧脑",
        },
        {
          id: 1,
          name: "末日余生",
          url: require("@/assets/images/icon/icon4.png"),
          desc:
            "末日余生是支持双人联机的恐怖射击类游戏，适配主流一体机产品。游戏中拥有多样化的枪械设定和丰富的丧尸种类，玩家在制作精良的昏暗场景和若隐若无的丧尸吼叫中，体验最直接的恐怖感受，让玩家沉浸在恐怖的氛围中，面对不断来袭的丧尸，挣扎求生。",
          kid: "标签：游戏、射击、恐怖、生存、合作",
        },
        {
          id: 2,
          name: "末日余生2",
          url: require("@/assets/images/icon/icon3.png"),
          desc:
            "生化僵尸一体机产品，支持多人联机体验，感受丧尸扑面而来的紧张感和压抑感，2019年11月中旬上线VIVE PORT商城，2020年四月上线华为VR商城，是目前商城中画质和体验最好的丧尸产品。",
          kid: "标签：游戏、桌游、烧脑",
        },
        {
          id: 3,
          name: "藏宝湾",
          url: require("@/assets/images/icon/icon2.png"),
          desc:
            "藏宝湾是一款卡通站立式塔防VR产品，支持最多4人联机游戏，在遥远的黄金岛上，联手对抗源源不断入侵的海盗。面对海盗大军的不断来袭，玩家们需要合理地利用岛上的防御设施，妥善地分配道具，以及过人的智慧和精妙的配合，战胜强大的BOSS和他的海岛大军，守护黄金岛的宝藏。",
          kid: "标签：游戏、射击、卡通、合作",
        },

        {
          id: 6,
          name: "阴囚",
          url: require("@/assets/images/icon/icon7.png"),
          desc:
            "大空间密室逃脱+恐怖解谜产品，在4*4平方面积对应生成随机场景，玩家在空间内自由探索，解开谜题，逃出密室。无限迷宫体验无限",
          kid: "标签：游戏、恐怖、解密、密室逃生",
        },
        {
          id: 5,
          name: "星际奇兵",
          url: require("@/assets/images/icon/icon6.png"),
          desc:
            "太空题材BOSS战类型产品，宏大的场景，炫酷的武器和强大的boss带给玩家亲临战场，参与一场史诗级战斗的绝妙体验。已于2019年10月上线HTC VIVE PORT商城，联网合作版本开发迭代中，为玩家提供全新的战斗体验。",
          kid: "标签：游戏、射击、策略",
        },
        {
          id: 4,
          name: "星际战场",
          url: require("@/assets/images/icon/icon5.png"),
          desc:
            "星际战场为玩家营造了一个极度逼真的太空环境。让体验者在一艘遨游太空的星际运输船上进行激烈的团队死斗，与队友一起击溃对手赢得最终的荣誉。 依托于FOCUS PLUS6+6自由度的硬件支持，我们将传统3自由度的游戏体验升级提升为全面六自由度的操控方式，让游戏体验变得更加自由灵活，充满了更多技战特性。",
          kid: "标签：游戏、射击、多人对战",
        },
      ],
      bannerList: [
        {
          id: 0,
          url: require("@/assets/images/bannerList/banner1.jpg"),
          text: "藏宝湾",
        },
        {
          id: 1,
          url: require("@/assets/images/bannerList/banner2.jpg"),
          text: "星际骑兵",
        },
        {
          id: 2,
          url: require("@/assets/images/bannerList/banner3.jpg"),
          text: "星际战场",
        },
        {
          id: 3,
          url: require("@/assets/images/bannerList/banner4.jpg"),
          text: "阿瓦隆",
        },
        {
          id: 4,
          url: require("@/assets/images/bannerList/banner5.jpg"),
          text: "末日余生",
        },
        {
          id: 5,
          url: require("@/assets/images/bannerList/banner6.jpg"),
          text: "末日余生2",
        },
        {
          id: 6,
          url: require("@/assets/images/bannerList/banner7.png"),
          text: "阴囚",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 28px;
}
a {
  margin-top: 10px;
  text-align: center;
  color: #999;
  display: inline-block;
  width: 100%;
}
.home {
  .el-carousel {
    // border: 1px solid red;
    // height: 800px;
    .el-carousel__item {
      height: 100%;
      border-radius: 10px;
      .el-image {
        height: 100%;
        width: 100%;
        // border-radius: 10px;
      }
      .banner-item {
        position: absolute;
        font-size: 32px;
        top: 20px;
        left: 20px;
        color: #fff;
        text-align: center;
        z-index: 1;
      }
    }
  }
}

.el-card {
  cursor: pointer;
  .game {
    display: flex;
    .el-image {
      width: 100px;
      height: 100px;
      border: 1px solid #eee;
      border-radius: 10px;
    }
    .right {
      margin-left: 20px;
      flex: 3;
      .title {
        color: #e72d33;
        font-size: 24px;
      }
      .desc {
        font-size: 16px;
        color: #999;
        margin-top: 5px;
      }
      .kid {
        color: #999;
        font-size: 13px;
        margin-top: 10px;
      }
    }
  }
}
.mt {
  margin-top: 20px;
}
.mb {
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .el-carousel {
    // height: 400px !important;
    // border: 1px solid purple;
  }
  h1 {
    font-size: 18px;
  }
  .title {
    font-size: 16px !important;
  }
}

@media screen and(max-width: 680px) {
  .home {
    padding: 0;
    // border: 1px solid #000;
  }
  .el-carousel {
    // height: 200px !important;
  }

  .el-card {
    .game {
      .right {
        // margin-left: 20px;
        flex: 3;
        .title {
          color: #e72d33;
          font-size: 20px;
        }
        .desc {
          font-size: 12px !important;
          color: #000;
          margin-top: 5px;
        }
        .kid {
          color: #999;
          font-size: 13px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
